// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__y-C_U","noPadding":"Modal_noPadding__weQAq"};